import { ConstantsLagoon } from '@/common/constants';
import { useLagoon } from '@/hooks/useLagoon';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { find } from 'lodash';
import React from 'react';
import { PortalName } from '@/common/DataModel/PortalData';
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import {
  StyledErrorMessage,
  StyledErrorTitle,
  StyledIconBrand,
  StyledIconSymbol,
  pageBodyMaxWidth,
} from './SignedOutModal.styles';

interface Props {
  portalIdentifier: string | undefined;
}

export const SignedOutModal = ({ portalIdentifier }: Props) => {
  const mobileScreen = useMediaQuery(`(max-width: ${pageBodyMaxWidth}px)`);
  const containerUiMessagingData = useLagoon('container-ui-messaging')();

  const sessionEndedMessaging = find(containerUiMessagingData, {
    key: ConstantsLagoon.CONTAINER_CONFIG.SECURE_SESSION_ENDED,
  });

  const isGeha = portalIdentifier?.toLowerCase() === PortalName.GEHA;

  return (
    <Modal
      data-auto-testid="signed-out-modal"
      data-testid="signed-out-modal"
      closeOnClickOutside={false}
      closeOnEscPress={false}
      isOpen={true}
      size={mobileScreen ? 320 : 624}
      css={{
        'abyss-modal-close-button': { visibility: 'hidden' },
      }}
    >
      <Layout.Stack alignLayout="center" alignItems="center" space={0}>
        {isGeha ? (
          <StyledIconSymbol
            data-auto-testid="geha-warning-icon-signed-out-modal"
            data-testid="geha-warning-icon-signed-out-modal"
            icon="warning"
            size={84}
            color="$primary"
            variant="outlined"
          />
        ) : (
          <StyledIconBrand
            data-auto-testid="umr-warning-icon-signed-out-modal"
            data-testid="umr-warning-icon-signed-out-modal"
            color="$interactive1"
            icon="alert"
            size={84}
            variant="twotone"
          />
        )}
        <StyledErrorTitle>{sessionEndedMessaging?.title}</StyledErrorTitle>
        <StyledErrorMessage>
          {sessionEndedMessaging?.message}
        </StyledErrorMessage>
      </Layout.Stack>
    </Modal>
  );
};
